module.exports = __webpack_public_path__ + "img/maintenance1.f1f5e427.jpeg";